import React, { useState } from 'react';
import { Tabs, Tab, Typography, Box } from '@material-ui/core';
import ImageBlocks from '../../../ImageBlocks';
import './Departments.css';

const Departments = ({ reference }) => {
  const [value, setValue] = useState(0);

  let departmentImages = []

  switch (value) {
    case 0:
      departmentImages = [
        '2p-1.jpeg',
        '2p-2.jpeg',
        '2p-3.jpeg',
      ];
      break;
    case 1:
      departmentImages = [
        '4p-1.jpeg',
        '3p-2.jpg',
        '3p-3.jpg',
      ];
      break;
    case 2:
      departmentImages = [
        '4p-2.jpeg',
        '4p-3.jpeg',
        '4p-1.jpeg',
      ];
      break;
    case 3:
      departmentImages = [
        '6p-1.jpg',
        '6p-2.jpg',
        '6p-3.jpg',
      ];
      break;
    default:
      break;
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="Departments Departments__Container" ref={reference}>
      <div className="Departments__Title">
        <Typography variant="h5" color="primary">
          Departamentos para alquilar
        </Typography>
      </div>

      <div className="Departments__Content">
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          value={value}
          onChange={handleChange}
          aria-label="Tipos de departamentos para alquilar"
        >
          <Tab label="2 Personas" />
          <Tab label="2 a 3 Personas" />
          <Tab label="4 a 5 Personas" />
          <Tab label="6 a 7 Personas" />
        </Tabs>

        <Box hidden={value !== 0} p={3}>
          <Typography variant="h6" color="primary">
            Suite en una sola planta
          </Typography>

          Dormitorio con cama matrimonial, con aire acondicionado, baño, cafetera, heladera y TV LCD32"
        </Box>
        <Box hidden={value !== 1} p={3}>
          <Typography variant="h6" color="primary">
            Departamento en una sola planta
          </Typography>

          Dormitorio con cama matrimonial y 1 single, con aire acondicionado, baño, cocina totalmente equipada con horno  micro-ondas, cocina eléctrica, cafetera, heladera, vajilla completa y comedor con TV LCD32"
        </Box>
        <Box hidden={value !== 2} p={3}>
          <Typography variant="h6" color="primary">
            Departamento de dos plantas
          </Typography>

          Planta baja: equipado con cocina con anafe, heladera, horno de microondas, vajilla completa, y TV LCD32" con DirectTV.
          Planta alta: dos habitaciones con balcón terraza y baño completo, dressoir y vestidor.
        </Box>
        <Box hidden={value !== 3} p={3}>
          <Typography variant="h6" color="primary">
            Departamento de dos plantas
          </Typography>

          Planta baja: equipado con cocina con anafe, heladera, horno de microondas, vajilla completa, TV LCD32" con DirectTV y baño completo.
          Planta alta: dos habitaciones con balcón terraza y baño completo, dressoir y vestidor.
        </Box>

        {departmentImages.length > 0 &&
          <ImageBlocks images={departmentImages} />
        }
      </div>
    </div>

  );
};

export default Departments;
